import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedDoc: {},
  parentCustomerCode: '',
  docDate: null, // Add docDate field to store user-selected date
  postingDate: null, // For today's posting date
  remarks: '', // Add remarks field to store user-edited remarks
};

const transferInSlice = createSlice({
  name: "transferInStore",
  initialState: initialState,
  reducers: {
    // Added updateSelectedDoc reducer
    updateSelectedDoc: (state, action) => {
      state.selectedDoc = action.payload;
    },

    // In your transferInSlice.js
    updateData: (state = initialState, action) => {
      console.log('Redux update - incoming dates:', {
        docDate: action.payload.selectedDoc?.DOCUMENT_DATE,
        effectiveDate: action.payload.selectedDoc?.EFFECTIVE_DATE
      });

      state.selectedDoc = { ...state.selectedDoc, ...action.payload.selectedDoc };

      console.log('Redux update - after merge:', {
        docDate: state.selectedDoc.DOCUMENT_DATE,
        effectiveDate: state.selectedDoc.EFFECTIVE_DATE
      });
    },

    updateSelectedItems: (state = initialState, action) => {
      state.selectedDoc = { ...state.selectedDoc, ...action.payload };
    },

    setParentCustomerCode: (state, action) => {
      state.parentCustomerCode = action.payload; // Store selected customer code
    },

    setRemarks: (state, action) => {
      state.remarks = action.payload;
      if (state.selectedDoc) {
        state.selectedDoc.REMARK = action.payload;
      }
    },

    // Modified setDocDate to update both locations
   setDocDate: (state, action) => {
  const dateString = action.payload;
  state.docDate = dateString;
  if (state.selectedDoc) {
    state.selectedDoc.DOCUMENT_DATE = dateString;
    state.selectedDoc.EFFECTIVE_DATE = dateString; // ← ADD THIS LINE
  }
},

    setPostingDate: (state, action) => {
      const dateString = action.payload;
      state.postingDate = dateString;
      if (state.selectedDoc) {
        // Only update if it's not already set
        state.selectedDoc.EFFECTIVE_DATE = state.selectedDoc.EFFECTIVE_DATE || dateString;
      }
    },

    resetData: () => {
      return initialState;
    },
  },
});

export const {
  updateSelectedDoc, // Added to exports
  updateData,
  updateSelectedItems,
  setParentCustomerCode,
  setDocDate,
  setRemarks,
  setPostingDate,
  resetData
} = transferInSlice.actions;

export default transferInSlice.reducer;
